<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("routes.withdraw_plans") }}</v-toolbar-title>
    </v-toolbar>

    <!-- table -->
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      pathName="withdraw-orders"
      resName="withdraw_orders"
      class="table-row"
      @get_items="getItems"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">
          {{ item.amount }}
        </td>
        <td class="text-sm-center">
          {{ item.wallet.balance }}
        </td>
        <td class="text-sm-center">
          {{
            item.done_at
              ? $moment(item.done_at).format("YYYY-MM-DD")
              : $t("not_yet")
          }}
        </td>
        <td class="text-sm-center">
          {{
            item.seen_at
              ? $moment(item.seen_at).format("YYYY-MM-DD")
              : $t("not_yet")
          }}
        </td>

        <td class="text-sm-center">
          <v-btn @click="handleShow(item, index)" icon color="info">
            <v-icon :title="$t('icon.show')" small>mdi-eye</v-icon>
          </v-btn>
        </td>
      </template>
    </wrapping-table>
    <!-- table -->
    <v-dialog v-model="dialog" max-width="700">
      <v-card max-width="700">
        <template v-if="!loading">
          <v-card-title>
            <span class="font-bold">{{ $t("widthdrw_details") }}</span>
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-5">
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ withdraw_order.amount }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  {{ $t("table.amount") }}
                </v-list-item-action>
              </v-list-item>
              <v-divider />
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ withdraw_order.wallet && withdraw_order.wallet.balance }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  {{ $t("table.balance") }}
                </v-list-item-action>
              </v-list-item>
              <v-divider />

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      withdraw_order.seen_at
                        ? $moment(withdraw_order.seen_at).format("YYYY-MM-DD")
                        : $t("not_yet")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  {{ $t("table.seen_at") }}
                </v-list-item-action>
              </v-list-item>
              <v-divider />

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      withdraw_order.dont_at
                        ? $moment(withdraw_order.done_at).format("YYYY-MM-DD")
                        : $t("not_yet")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  {{ $t("table.done_at") }}
                </v-list-item-action>
              </v-list-item>
              <template
                v-if="
                  withdraw_order.wallet && withdraw_order.wallet.bank_account
                "
              >
                <v-divider />
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ withdraw_order.wallet.bank_account.bank_name }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ $t("table.bank_name") }}
                  </v-list-item-action>
                </v-list-item>
                <v-divider />
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ withdraw_order.wallet.bank_account.branch_name }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ $t("table.branch_name") }}
                  </v-list-item-action>
                </v-list-item>
                <v-divider />
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ withdraw_order.wallet.bank_account.account_number }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ $t("table.account_number") }}
                  </v-list-item-action>
                </v-list-item>
                <v-divider />
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{
                        withdraw_order.wallet.bank_account.account_holder_name
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ $t("table.account_holder_name") }}
                  </v-list-item-action>
                </v-list-item>
                <v-divider />
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ withdraw_order.wallet.bank_account.iban }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ $t("table.iban") }}
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="12">
                <date-time-picker
                  v-model.trim="form.done_at"
                  filled
                  :date-time="form.done_at"
                  :text-field-props="{
                    filled: true,
                    'prepend-icon': 'mdi-calendar'
                  }"
                  time-format="HH:mm:ss"
                ></date-time-picker>
              </v-col>
              <v-col cols="12" class="mb-10">
                <v-btn
                  :loading="loadingBtn"
                  @click="handleUpdate"
                  :disabled="form.done_at === ''"
                  block
                  class="primary"
                  height="64px"
                >
                  <span class="font-bold" style="font-size: 16px">{{
                    $t("button.update")
                  }}</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </template>
        <div v-else>
          <div
            style="
              height: 300px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <v-progress-circular
              color="primart"
              indeterminate
              size="70"
            ></v-progress-circular>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </main>
</template>

<script>
import { ShowData, UpdateData } from "@/helpers/apiMethods";
export default {
  name: "Withdraw",
  components: {
    DateTimePicker: () => import("@/components/DateTimePicker")
  },
  data() {
    return {
      withdraw_order: {},
      items: [],
      itemIndex: 0,
      dialog: false,
      menu: false,
      loading: false,
      loadingBtn: false,
      headers: ["amount", "balance", "done_at", "seen_at", "actions"],
      form: {
        done_at: "",
        _method: "put"
      }
    };
  },
  methods: {
    getItems(items) {
      this.items = items;
    },
    handleShow(item, index) {
      this.dialog = true;
      this.itemIndex = index;
      this.loading = true;
      ShowData({ reqName: "withdraw-orders", param: item.id }).then(res => {
        const { withdraw_order } = res.data;
        this.withdraw_order = withdraw_order;
        this.form.done_at =
          withdraw_order.done_at && new Date(withdraw_order.done_at);
        this.loading = false;
        this.$set(this.items, this.itemIndex, withdraw_order);
      });
    },
    clearData() {
      this.form.done_at = "";
      this.dialog = false;
    },
    handleUpdate() {
      this.loadingBtn = true;
      const reqData = {
        ...this.form,
        done_at: this.$moment(this.form.done_at).format("YYYY-MM-DD H:m:ss")
      };
      UpdateData({
        reqName: "withdraw-orders",
        param: this.withdraw_order.id,
        data: reqData
      })
        .then(res => {
          const { withdraw_order } = res.data;

          this.$set(this.items, this.itemIndex, withdraw_order);
          this.clearData();
        })
        .finally(() => (this.loadingBtn = false));
    }
  }
};
</script>
